import { configureStore } from "@reduxjs/toolkit";
import { listenerMiddleware } from "./listenerMiddleware";
import { enableMapSet } from "immer";

// Import all slices
import lobbyReducer from "./slices/lobbySlice";
import gameReducer from "./slices/gameTableSlice";
import sliderReducer from "./slices/sliderSlice";
import modalReducer from "./slices/modalSlice";
import buttonReducer from "./slices/buttonSlice";
import alertReducer from "./slices/alertSlice";
import clientLogsReducer from "./slices/clientLogsSlice";
import timersReducer from "./slices/timersSlice";
import statsRedcer from "./slices/statsSlice";

import './listeners/timerListeners'; // Ensure this import is after all slices are defined
// This import will register the timer listeners and ensure they are set up correctly

enableMapSet(); // Enable support for Map & Set in Immer

// Configure the Redux store
const store = configureStore({
  reducer: {
    lobby: lobbyReducer,
    modal: modalReducer,
    gameTable: gameReducer,
    slider: sliderReducer,
    button: buttonReducer,
    alert: alertReducer,
    clientLogs: clientLogsReducer,
    timers: timersReducer,
    stats: statsRedcer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).prepend(listenerMiddleware.middleware),
});

export default store;
